import { styledBox } from "../../../themes/architecture/styled-box";


export const HomePageHeaderArenasBox = styledBox('HomePageHeaderArenasBox')